class PredictiveSearchCustom extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");
    this.predictiveSearchResultsinMain =
      document.querySelector("#predictive-search");
    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    this.clearButton = this.querySelector(".predictive-search__clear");
    this.clearclose = this.querySelector(".search-bar__close-icon");
    this.clearText();
    this.buttonClose();
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      this.clearButton.style.display = "none";
      return;
    }
    this.getSearchResults(searchTerm);
    this.clearButton.style.display = "block";
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.predictiveSearchResultsinMain.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResultsinMain.style.display = "block";
  }

  close() {
    this.predictiveSearchResultsinMain.style.display = "none";
  }

  clearText() {
    this.clearButton.addEventListener("click", (event) => {
      event.preventDefault();
      const inputField = this.querySelector('input[type="search"]');
      if (inputField) {
        inputField.value = "";
      }
      this.close();
      inputField.focus();
    });
  }

  buttonClose() {
    this.clearclose.addEventListener("click", () => {
      this.clearText();
      this.close();
    });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search-custom", PredictiveSearchCustom);
